import z from "zod"

export const QueryTypename = "Query" as const
export const MutationTypename = "Mutation" as const
export const DeleteResponseTypename = "DeleteResponse" as const

export const MutationSchema = z.object({
  __typename: z
    .literal(MutationTypename)
    .nullish()
    .transform(() => MutationTypename)
})
